<template>
  <Main>
    <v-container style="height: 200vh">
      <v-card>
        <v-card-text>
          <p class="display-1 text--primary">Overview File CRC</p>
          <v-row class="mt-4">
            <v-col class="py-0" md="4" sm="12">
              <!-- <v-select
                color="red darken-1"
                item-value="POSITION_CODE"
                item-text="POSITION_CODE"
                v-model="PositionCode"
                :items="PositionCodeList"
                label="Position"
                :filter="customFilter"
                @change="getPositionCode"
                dense
                outlined
              ></v-select> -->
              <template v-slot:prepend-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-text-field
                      v-model="searchPosition"
                      placeholder="Search"
                      @input="searchChoosePoition"
                    ></v-text-field>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>
              <v-select
                color="red darken-1"
                item-value="POSITION_CODE"
                item-text="POSITION_CODE"
                v-model="PositionCode"
                :items="listPositionCopy"
                label="Position"
                @change="getPositionCode"
                dense
                outlined
              >
                <template v-slot:prepend-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-text-field
                        v-model="searchPosition"
                        placeholder="Search"
                        @input="searchChoosePoition"
                      ></v-text-field>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
              </v-select>
            </v-col>
            <v-col class="py-0" md="4" sm="12">
              <v-menu
                v-model="isShowStartDate"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    color="red darken-1"
                    class="mt-0 pt-0"
                    v-model="startDate"
                    label="Start Date"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="startDate"
                  @input="isShowStartDate = false"
                  color="red darken-1"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col class="py-0" md="4" sm="12">
              <v-menu
                v-model="isShowEndDate"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    color="red darken-1"
                    class="mt-0 pt-0"
                    v-model="endDate"
                    label="End Date"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="endDate"
                  @input="isShowEndDate = false"
                  color="red darken-1"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col class="text-right py-0" md="4">
              <v-btn
                class="w-100"
                style="width: 100%; marginBottom: 20px"
                color="warning"
                @click="getOverview()"
                >SEARCH</v-btn
              >
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <template v-if="dtItems.length > 0">
        <v-row class="searchfield">
          <v-col cols="6"> </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="search"
              label="Search Customer Name"
              clearable
              prepend-inner-icon="mdi-magnify"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row class="mt-4">
          <v-col
            v-for="(items, index) in paginatedItems"
            :key="index"
            cols="12"
            sm="6"
            md="4"
          >
            <v-card
              style="borderRadius: 17px !important"
              class="hover-card"
              elevation="2"
              @mouseover="hover = true"
              @mouseleave="hover = false"
              outlined
            >
              <v-img
                :src="items.ATTACHMENT_FILE.result"
                alt="Image not found"
                height="200px"
              ></v-img>

              <v-row no-gutters>
                <v-col>
                  <v-sheet class="pa-2 ma-2 titlelist"> Nama Relasi </v-sheet>
                </v-col>
                <v-col>
                  <v-sheet class="pa-2 ma-2">
                    {{ items.CUSTOMER_OUTLET }}
                  </v-sheet>
                </v-col>

                <v-responsive width="100%"></v-responsive>

                <v-col>
                  <v-sheet class="pa-2 ma-2 titlelist"> Tgl Kunjungan </v-sheet>
                </v-col>

                <v-col>
                  <v-sheet class="pa-2 ma-2">
                    {{ items.DATE_PLAN }}
                  </v-sheet>
                </v-col>

                <v-responsive width="100%"></v-responsive>

                <v-col>
                  <v-sheet class="pa-2 ma-2 titlelist"> Kategori </v-sheet>
                </v-col>

                <v-col>
                  <v-sheet class="pa-2 ma-2">
                    {{ items.DISPLAY_TYPE }}
                  </v-sheet>
                </v-col>

                <v-responsive width="100%"></v-responsive>

                <v-col>
                  <v-sheet class="pa-2 ma-2 titlelist"> Sublini </v-sheet>
                </v-col>

                <v-col>
                  <v-sheet class="pa-2 ma-2">
                    {{ items.SUB_LINE_DESC }}
                  </v-sheet>
                </v-col>
              </v-row>
              <div class="poitionbtn">
                  <v-btn class="btndownlod" @click="downloadImage(items)" icon>
                    <v-icon>mdi-download</v-icon>
                  </v-btn>
                </div>
              <v-divider></v-divider>
            </v-card>
          </v-col>
        </v-row>

        <v-row justify="center">
          <v-pagination
            v-model="currentPage"
            :length="totalPages"
            :total-visible="5"
            circle
          ></v-pagination>
        </v-row>
      </template>
      <template v-else></template>
    </v-container>

    <!-- SNACKBAR -->
    <v-snackbar v-model="isShowSnackbar" top>{{ snackbarText }}</v-snackbar>
    <!-- LOADING OVERLAY -->
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- MODAL -->
    <v-row justify="center">
      <v-dialog
        v-if="isShowPreview"
        v-model="isShowPreview"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="warning">
            <v-btn icon dark @click="isShowPreview = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Preview Attachment</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark text @click="isShowPreview = false">Close</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-container fluid>
            <PreviewImage :imageList="imageList"></PreviewImage>
          </v-container>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- END MODAL -->
  </Main>
</template>

<style>
.acrylic {
  background-color: rgb(223, 255, 210);
}
.csslist {
  margin-left: 20px;
  font-size: 12px;
  color: gray;
}
.spacedownload {
  display: flex;
  justify-content: space-between;
}
.btndownlod {
  color: gray;
  display: flex;
  justify-items: flex-end;
}

.searchfield {
  margin-top: 20px;
}

.hover-card {
  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
}

.hover-card:hover {
  transform: translateY(-8px);
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2);
}
.v-application .ma-2 {
  margin-left: 10px !important;
  font-size: 12px;
  border-radius: 17px;
}

.v-application .pa-2 {
  padding: 0px !important;
  border-radius: 17px;
}
.v-application .ma-2 {
  margin: 0px !important;
  border-radius: 17px;
  margin-left: 10px !important;
}

.titlelist {
  font-weight: bold;
}

.poitionbtn {
  display: flex;
  justify-content: flex-end;
}
</style>

<script>
import Main from "@/Main.vue";
import PreviewImage from "./PreviewImage";
import moment from "moment";
import AWS from "aws-sdk";
import { S3_CONNECTION } from "../../lib/config";
import FileSaver from "file-saver";
import { log } from "handlebars/runtime";

const s3 = new AWS.S3(S3_CONNECTION);

export default {
  components: {
    Main,
    PreviewImage,
  },
  data() {
    return {
      dtHeaders: [
        {
          text: "Area Code",
          value: "BRANCH_CODE",
        },
        {
          text: "Position Code",
          value: "POSITION_CODE",
        },
        {
          text: "Employee Name",
          value: "SALESREP_EMPLOYEE_NAME",
        },
        {
          text: "Customer Name",
          value: "CUSTOMER_NAME",
        },
        {
          text: "Date CRC",
          value: "DATE_CRC",
        },
        {
          text: "Product Group",
          value: "PRODUCT_GROUP_CODE",
        },
        {
          text: "ACRY",
          value: "IS_ACRYLIC",
        },
        {
          text: "Attachment",
          value: "edit",
          sortable: false,
        },
      ],
      isAcrylicList: ["Y", "N"],
      isAcrylic: "Y",
      dtItems: [],
      searchPosition: "",
      search: "",
      dtLoading: false,
      isLoading: false,
      isShowSnackbar: false,
      snackbarText: "",
      isShowData: true,
      startDate: moment().startOf("month").format("YYYY-MM-DD"),
      endDate: moment().endOf("month").format("YYYY-MM-DD"),
      isShowStartDate: false,
      isShowEndDate: false,
      BranchList: [],
      BisnisList: [],
      listPositionCopy: [],
      Bisnis: "",
      BranchCode: "ALL",
      PositionCodeList: [],
      PositionCode: "",
      isShowPreview: false,
      imageList: [],
      acrylicCounter: {
        VERIFIED: 0,
        TOTAL: 0,
      },
      itemsPerPage: 6,
      currentPage: 1,
      totalRelasi: 0,
      imageServer: "",
      orgID: JSON.parse(localStorage.getItem("userData")).ORG_ID,
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.dtItems.length / this.itemsPerPage);
    },
    paginatedItems() {
      const searchTerm = this.search.toLowerCase();
      let newdata = this.dtItems.filter((item) =>
        item.CUSTOMER_OUTLET.toLowerCase().includes(searchTerm)
      );
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return newdata.slice(start, end);
    },
  },

  created() {
    if (this.$env == "DEV") {
      this.imageServer = "http://localhost:8080";
    } else if (this.$env == "UAT") {
      this.imageServer = "https://imaps.anugrah-argon.com";
    }
    this.listPositionCopy = [...this.PositionCodeList];
  },

  mounted() {
    this.getPosition();
    this.dtLoading = false;
  },
  methods: {
    searchChoosePoition(e) {
      const query = this.searchPosition.toLowerCase();
      this.listPositionCopy = this.PositionCodeList.filter((position) =>
        position.POSITION_CODE.toLowerCase().includes(query)
      );
    },

    downloadImage(val) {
      let file = val.FILENAME.split("/");
      let newfile = file.slice(-1)[0];
      fetch(val.ATTACHMENT_FILE.result)
        .then((response) => response.blob())
        .then((blob) => {
          saveAs(blob, newfile);
        })
        .catch((error) => console.error("Error fetching image:", error));
    },

    itemRowBGDtTable: function (item) {
      return item.IS_ACRYLIC == "Y" ? "acrylic" : "";
    },
    counterAcrylic(IS_ACRYLIC) {
      if (IS_ACRYLIC == "Y") {
        this.acrylicCounter.VERIFIED += 1;
        this.acrylicCounter.TOTAL += 1;
      } else {
        this.acrylicCounter.TOTAL += 1;
      }
    },
    fullSizeImage() {
      console.log("fullSizeImage");
    },
    previewItem(item) {
      this.isLoading = true;
      this.$http
        .post(
          "/file-viewer/detailOverview",
          {
            // CRCHeaderID: 33,
            CRCHeaderID: item.CRC_HEADERID,
          },
          {
            headers: {
              "api-key": this.$apiKey,
            },
          }
        )
        .then(async (res) => {
          const { data } = res.data;
          this.imageList = data;
          for (let i = 0; i < this.imageList.length; i++) {
            if (this.imageList[0].ATTACHMENT_FILE.includes("/api")) {
              this.imageList[i].src =
                this.imageServer + this.imageList[i].ATTACHMENT_FILE;
            } else {
              const params = {
                Bucket: S3_CONNECTION.accessKeyId,
                Key: this.imageList[i].ATTACHMENT_FILE,
              };
              const imageSrc = await s3.getObject(params).promise();
              this.imageList[
                i
              ].src = `data:image/jpeg;base64,${imageSrc.Body.toString(
                "base64"
              )}`;
            }
          }
          this.isLoading = false;
          this.isShowPreview = true;
          this.isPreparingSPV = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.isPreparingSPV = false;
          this.showSnackbar(err.toString());
        });
    },

    getPositionCode(val) {
      this.PositionCode = val;
    },

    getPosition() {
      let data = {
        orgID: this.orgID,
      };
      this.isLoading = true;
      this.dtLoading = true;
      this.$http
        .post("/adjust-incentive/getSalesRepStructure", data, {
          headers: {
            "api-key": this.$apiKey,
          },
        })
        .then((res) => {
          console.log(res.data);
          let { success, message, data } = res.data;
          if (success) {
            this.isLoading = false;
            this.dtLoading = false;
            this.isShowData = true;
            this.PositionCodeList = data;
            this.listPositionCopy = data;
            this.showSnackbar("Get Data Success...");
          } else {
            this.isLoading = false;
            this.isShowData = false;
            this.showSnackbar(message);
          }
        })
        .catch((err) => {
          this.isLoading = false;
          this.isShowData = false;
          this.showSnackbar(err.toString());
        });
    },

    getOverview() {
      let data = {
        BranchCode: this.PositionCode,
        StartDate: this.startDate,
        EndDate: this.endDate,

        // BranchCode: "AMJK3SANI ALL-5-A",
        // StartDate: "2024-11-29",
        // EndDate: "2024-12-29",
      };

      this.isLoading = true;
      this.dtLoading = true;
      this.$http
        .post("/file-viewer/overviewNew", data, {
          headers: {
            "api-key": this.$apiKey,
          },
        })
        .then((res) => {
          let { success, message, data } = res.data;
          if (success) {
            this.isLoading = false;
            this.dtLoading = false;
            this.isShowData = true;

            this.dtItems = data;
            this.showSnackbar("Get Data Success...");
          } else {
            this.isLoading = false;
            this.isShowData = false;
            this.showSnackbar(message);
          }
        })
        .catch((err) => {
          this.isLoading = false;
          this.isShowData = false;
          this.showSnackbar(err.toString());
        });
    },
    showSnackbar(text) {
      this.snackbarText = text;
      this.isShowSnackbar = true;
    },
  },
};
</script>
